import { render, staticRenderFns } from "./CollaboratorCard.vue?vue&type=template&id=5e1a15ef&scoped=true"
import script from "./CollaboratorCard.vue?vue&type=script&lang=js"
export * from "./CollaboratorCard.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorCard.vue?vue&type=style&index=0&id=5e1a15ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1a15ef",
  null
  
)

export default component.exports